import React, { useState, useEffect, useRef } from "react";
import api from "../api";
import CustomButton from "../components/CustomButton";
import ModalForm from "../components/ModalForm";
import CustomTextInput from "../components/CustomTextInput";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import CustomSelect from "../components/CustomSelect";
import InfoCard from "../components/InfoCard";
import DashboardTable from "../components/DashboardTable";
import DateRangePicker from "../components/DateRangePicker";
import { format, parseISO } from "date-fns";
import CustomAutoComplete from "../components/CustomAutoComplete";
import CustomTextarea from "../components/CustomTextarea";
import GooglePlacesInput from "../components/GooglePlacesInput";
import ClientModal from "../components/dashboard/ClientModal";
import CarModal from "../components/dashboard/CarModal";
import DriverModal from "../components/dashboard/DriverModal";
import CarAvailabilityModal from "../components/CarAvailabilityModal";
import ModalTripClosure from "../components/ModalTripClosure";
import ModalCenter from "../components/ModalCenter";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomPhoneInput from "../components/CustomPhoneInput";
import CurrencyInput from "../components/CurrencyInput";
import { parse } from "date-fns";

export default function RidesPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [driverSelect, setDriverSelect] = useState("");
  const [carSelect, setCarSelect] = useState("");

  const [clientName, setClientName] = useState("");
  const [passenger, setPassenger] = useState("");
  const [passengerNumber, setPassengerNumber] = useState("");
  const [drivers, setDrivers] = useState("");
  const [driver, setDriver] = useState("");
  const [pickup, setPickup] = useState("");
  const [destination, setDestination] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [cars, setCars] = useState("");
  const [car, setCar] = useState("");
  const [voucher, setVoucher] = useState("");
  const [flightNumber, setflightNumber] = useState("");
  const [obs, setObs] = useState("");
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState(1);

  const [currentSearch, setCurrentSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(currentSearch);
  const searchInputRef = useRef(null);

  const [selectedRange, setSelectedRange] = useState(null);

  const [isAddNewModalOpen, setIsAddNewModalOpen] = useState(false);
  const [addNewType, setAddNewType] = useState(""); // Tipo de entidad: 'client', 'driver', 'car'

  const [newClientAdded, setNewClientAdded] = useState(false);
  const [newDriverAdded, setNewDriverAdded] = useState(false);
  const [newCarAdded, setNewCarAdded] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const [flag, setFlag] = useState(false);

  // Obtener el estado pasado desde Login
  const isLogin = location.state?.isLogin || false;

  const [quoterRides, setQuoterRides] = useState(false);

  const [isCarModalStatus, setIsCarModalStatus] = useState(false);

  const [openClosure, setOpenClosure] = useState(false);
  const [selectedElement, setSelectedElement] = useState(null);
  const [tripClosure, setTripClosure] = useState(false);

  const [filteredRides, setFilteredRides] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [whatsAppMessage, setWhatsAppMessage] = useState("");
  const [currentRow, setCurrentRow] = useState(null);

  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviewMessage, setReviewMessage] = useState("");
  const [reviewPhone, setReviewPhone] = useState("");

  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const [ridesWithIssues, setRidesWithIssues] = useState([]);

  const [dates, setDates] = useState([{ date: "", hour: "" }]);

  const addDateTime = () => {
    setDates((prev) => [...prev, { date: "", hour: "" }]);
  };

  const removeDateTime = (index) => {
    setDates((prev) => prev.filter((_, i) => i !== index));
  };

  const updateDateTime = (index, field, value) => {
    setDates((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  useEffect(() => {
    const now = new Date();
    const todayStr = now.toISOString().split("T")[0]; // 'YYYY-MM-DD'

    const filtered = data?.data?.filter((ride) => {
      return ride.date === todayStr && (!ride.driver || !ride.vehicle);
    });

    const issuesRides = [];

    filtered?.forEach((ride) => {
      // Verificamos que date y hour existan
      if (!ride.date || !ride.hour) return;

      // Construimos un Date completo con ride.date + ride.hour
      const rideDateTime = new Date(`${ride.date}T${ride.hour}`);

      const diffInMs = rideDateTime - now;
      const diffInMinutes = diffInMs / (1000 * 60);

      // Mostrar solo si faltan 60 min o menos y no está en el pasado
      if (diffInMinutes <= 60 && diffInMinutes >= 0) {
        const issues = [];

        if (!ride.pickup) issues.push("⚠️ No tiene un origen asignado.");
        if (!ride.destination) issues.push("⚠️ No tiene un destino asignado.");
        if (!ride.driver) issues.push("⚠️ No tiene conductor asignado.");
        if (!ride.vehicle) issues.push("⚠️ No tiene vehículo asignado.");

        if (issues.length > 0) {
          toast.error(
            `🚨 Viaje con problemas: ${ride.passenger} 
${issues.join("\n")}`,
            {
              onClick: () => handleDetailsClick(ride.id),
              style: { cursor: "pointer", whiteSpace: "pre-line" },
            }
          );

          issuesRides.push({ ...ride, issues });
        }
      }
    });

    setFilteredRides(filtered);
    setRidesWithIssues(issuesRides);
  }, [data]);

  const handleAddNew = (type) => {
    setIsModalOpen(false); // Cerrar el modal actual
    setAddNewType(type); // Guardar el tipo de entidad
    setIsAddNewModalOpen(true); // Abrir el modal para agregar
  };

  const closeModal = () => {
    setAddNewType("");
    setIsAddNewModalOpen(false);
    if (!flag) {
      setIsModalOpen(true);
    } else {
      setFlag(false);
    }
  };

  const handleClientAdded = (isAdded) => {
    setNewClientAdded(isAdded); // Actualiza el estado para indicar que se agregó un nuevo cliente
  };

  const handleDriverAdded = (isAdded) => {
    setNewDriverAdded(isAdded); // Actualiza el estado para indicar que se agregó un nuevo conductor
  };

  const handleCarAdded = (isAdded) => {
    setNewCarAdded(isAdded); // Actualiza el estado para indicar que se agregó un nuevo vehiculo
  };

  const handleRangeSelect = (range) => {
    console.log("Rango seleccionado:", range);
    setSelectedRange(range);
  };

  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});

  const serviceTypeOptions = [
    { value: 1, label: "Un solo tramo" },
    { value: 2, label: "Varios tramos" },
    { value: 3, label: "Half Day" },
    { value: 4, label: "Full Day" },
    { value: 5, label: "Viaje de larga distancia dentro del país" },
    { value: 6, label: "Viaje al exterior" },
    { value: 7, label: "Tour" },
    { value: 8, label: "Solo chofer" },
    { value: 9, label: "Valet parking" },
  ];

  const statusOptions = [
    { value: 1, label: "Agendado" },
    { value: 2, label: "Pendiente" },
    { value: 3, label: "En espera" },
    { value: 4, label: "Confirmado" },
    { value: 5, label: "Cerrado" },
    { value: 6, label: "Rechazado" },
    { value: 7, label: "Cancelado" },
  ];

  const columnsConfig = [
    { field: "client.name", headerName: "Cliente", sortable: true },
    { field: "passenger", headerName: "Pasajero", sortable: true },
    { field: "driver.name", headerName: "Conductor", sortable: true },
    { field: "pickup", headerName: "Origen", sortable: true },
    { field: "destination", headerName: "Destino", sortable: true },
    { field: "vehicle.name", headerName: "Vehículo asignado", sortable: true },
    { field: "vehicle.licensePlate", headerName: "Chapa", sortable: true },
    { field: "date", headerName: "Fecha", sortable: true },
    { field: "hour", headerName: "Hora", sortable: true },
    { field: "status", headerName: "Estado", sortable: true },
  ];

  useEffect(() => {
    const searchParam = searchParams.get("search") || "";
    setCurrentSearch(searchParam);
    setDebouncedSearch(searchParam);
  }, []);

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams.toString());

    if (debouncedSearch) {
      newParams.set("search", debouncedSearch);
    } else {
      newParams.delete("search");
    }

    setSearchParams(newParams);
    // Enfocar el input directamente usando querySelector
    /*setTimeout(() => {
      const input = document.querySelector("#search-input");
      if (input) input.focus();
    }, 500);*/
  }, [debouncedSearch]);

  useEffect(() => {
    async function fetchRides() {
      try {
        setLoading(true);
        // Configurar los filtros en el objeto `extra`

        const dateFrom = searchParams.get("date_from");
        const dateTo = searchParams.get("date_to");
        const clientParam = searchParams.get("client");
        const statusParam = searchParams.getAll("status");
        const serviceTypeParam = searchParams.get("service_type");
        const driverParam = searchParams.get("driver");
        const vehicleParam = searchParams.get("vehicle");

        // Comprobar si statusParam tiene valores reales
        const hasStatusParam = statusParam && statusParam.length > 0;

        let computedStatus;

        if (!status && !hasStatusParam) {
          // Al inicio, sin filtros -> excluir estado 5
          computedStatus = [1, 2, 3, 4, 6, 7];
        } else if (status === "ALL" || statusParam.includes("ALL")) {
          // Si se selecciona "ALL" -> incluir todos
          computedStatus = [1, 2, 3, 4, 5, 6, 7];
        } else {
          // Convertir string o array a array de números
          const rawStatus = status || statusParam;
          if (Array.isArray(rawStatus)) {
            computedStatus = rawStatus.map(Number);
          } else {
            computedStatus = [Number(rawStatus)];
          }
        }

        const extra = {
          date_from: selectedRange?.startDate
            ? format(new Date(selectedRange.startDate), "dd/MM/yyyy")
            : dateFrom,
          date_to: selectedRange?.endDate
            ? format(new Date(selectedRange.endDate), "dd/MM/yyyy")
            : dateTo,
          client: client || clientParam,
          status: computedStatus, // Asegurarse de enviar el valor correcto del estado
          service_type: type || serviceTypeParam,
          driver: driverSelect || driverParam,
          vehicle: carSelect || vehicleParam,
        };

        // Filtrar solo los parámetros definidos
        const validFilters = Object.fromEntries(
          Object.entries(extra).filter(([key, value]) => {
            if (key === "status") return true; // mantener status aunque sea array
            return value !== undefined && value !== null && value !== "ALL";
          })
        );

        console.log(validFilters);

        const paramsToSet = { ...validFilters };

        // Si el status fue generado por defecto (no vino de searchParams), no lo agregues al URL
        if (!status && !hasStatusParam) {
          delete paramsToSet.status;
        }

        if (debouncedSearch) {
          paramsToSet.search = debouncedSearch;
        }

        setSearchParams(paramsToSet);

        // Llamar al método getMultiRides con los filtros
        const response = await api.rides.getMultiRides(
          null,
          null,
          debouncedSearch,
          null,
          null,
          validFilters
        );

        setData(response);
        console.log("Datos recibidos:", response);
      } catch (error) {
        console.error("Error fetching rides:", error);
      } finally {
        setLoading(false);
      }
    }

    async function fetchMe() {
      try {
        const response = await api.users.getMe();
        setUser(response);
        if (isLogin && response.role === 1) {
          setQuoterRides(true);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }

    async function fetchClients() {
      try {
        const response = await api.clients.getMulti();
        setClients(response);
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    }

    async function fetchDrivers() {
      try {
        const response = await api.drivers.getMulti();
        setDrivers(response);
      } catch (error) {
        console.error("Error fetching drivers:", error);
      }
    }

    async function fetchCars() {
      try {
        const response = await api.vehicles.getMulti();
        setCars(response);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      }
    }

    fetchMe();
    fetchRides();
    fetchClients();
    fetchDrivers();
    fetchCars();
  }, [
    selectedRange,
    client,
    status,
    type,
    driverSelect,
    carSelect,
    newClientAdded,
    newDriverAdded,
    newCarAdded,
    tripClosure,
    searchParams,
    debouncedSearch,
    refreshTrigger,
  ]);

  useEffect(() => {
    if (!clients || !drivers || !cars) return;

    const clientParam = searchParams.get("client");
    const statusParam = searchParams.getAll("status");
    const serviceTypeParam = searchParams.get("service_type");
    const driverParam = searchParams.get("driver");
    const vehicleParam = searchParams.get("vehicle");
    const dateFromParam = searchParams.get("date_from");
    const dateToParam = searchParams.get("date_to");

    // Cliente
    if (clientParam && !client) {
      const foundClient = clients.find((c) => c.id.toString() === clientParam);
      if (foundClient) setClient(foundClient.id);
    }

    // Estado: NO seteamos "ALL" si no vino en la URL
    if (statusParam.length > 0 && !status) {
      if (statusParam.includes("ALL")) {
        setStatus("ALL");
      } else {
        const parsed = statusParam.map(Number);
        setStatus(parsed.length === 1 ? parsed[0] : parsed);
      }
    }

    // Tipo de traslado: solo setear si vino en la URL
    if (serviceTypeParam && !type) {
      setType(serviceTypeParam);
    }

    // Conductor
    if (driverParam && !driverSelect) {
      const foundDriver = drivers.find((d) => d.id.toString() === driverParam);
      if (foundDriver) setDriverSelect(foundDriver.id);
    }

    // Vehículo
    if (vehicleParam && !carSelect) {
      const foundCar = cars.find((v) => v.id.toString() === vehicleParam);
      if (foundCar) setCarSelect(foundCar.id);
    }

    // Rango de fechas
    if (dateFromParam && dateToParam && !selectedRange?.startDate) {
      setSelectedRange({
        startDate: parse(dateFromParam, "dd/MM/yyyy", new Date()),
        endDate: parse(dateToParam, "dd/MM/yyyy", new Date()),
      });
    }
  }, [clients, drivers, cars]);

  /*useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(currentSearch);
    }, 500); // Espera después de dejar de escribir

    return () => clearTimeout(timeout);
  }, [currentSearch]);*/

  // Función para limpiar filtros
  const clearFilters = async () => {
    setSelectedRange(null);
    setClient("");
    setStatus("");
    setType("");
    setDriverSelect("");
    setCarSelect("");
    setSearchParams({});
    setCurrentSearch("");
  };

  // Función para manejar el click en "Detalles"
  const handleDetailsClick = (rideId) => {
    navigate(`/rides/${rideId}`); // Redirige a la página de detalles del cliente
  };

  // Función para manejar el click en "Detalles"
  const handleTripClosure = (ride) => {
    setOpenClosure(true);
    setSelectedElement(ride);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    setFieldErrors({});

    try {
      // Creamos una promesa por cada fecha/hora
      const ridePromises = dates.map((item) => {
        const newRide = {
          client: clientName,
          passenger,
          passenger_contact: passengerNumber,
          driver,
          pickup,
          destination,
          serviceType,
          vehicle: car,
          date: item.date,
          hour: item.hour,
          status: 1,
          voucher_number: voucher,
          flight_number: flightNumber,
          observations: obs,
          amount: amount ? +amount : undefined,
          currency: +currency,
        };

        return api.rides.create(newRide);
      });

      // Ejecutamos todas las creaciones en paralelo
      await Promise.all(ridePromises);

      // Cerramos modal y reseteamos
      setIsModalOpen(false);
      setClientName("");
      setPassenger("");
      setPassengerNumber("");
      setDriver("");
      setPickup("");
      setDestination("");
      setServiceType("");
      setCar("");
      setDates([{ date: "", hour: "" }]); // Reiniciar a un par vacío
      setVoucher("");
      setflightNumber("");
      setObs("");
      setAmount("");
      setCurrency(1);

      setRefreshTrigger((prev) => !prev);

      // Filtros existentes
      const statusParam = searchParams.getAll("status");

      let computedStatus;
      if (!status && !statusParam) {
        computedStatus = [1, 2, 3, 4, 6, 7];
      } else if (status === "ALL" || statusParam === "ALL") {
        computedStatus = [1, 2, 3, 4, 5, 6, 7];
      } else {
        const rawStatus = status || statusParam;
        computedStatus = Array.isArray(rawStatus)
          ? rawStatus.map(Number)
          : [Number(rawStatus)];
      }

      const extra = {
        date_from: searchParams.get("date_from"),
        date_to: searchParams.get("date_to"),
        client: searchParams.get("client"),
        status: computedStatus,
        service_type: searchParams.get("service_type"),
        driver: searchParams.get("driver"),
        vehicle: searchParams.get("vehicle"),
      };

      const validFilters = Object.fromEntries(
        Object.entries(extra).filter(([key, value]) => {
          if (key === "status") return true;
          return value !== undefined && value !== null && value !== "ALL";
        })
      );

      /*const updatedRides = await api.rides.getMultiRides(
      null,
      null,
      null,
      null,
      null,
      validFilters
    );

    setData(updatedRides);*/
    } catch (error) {
      if (error.message) {
        const fieldErrors = error.message;
        setFieldErrors(fieldErrors);
      } else {
        setError("Error al crear el ride. Intenta nuevamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  const updateExchange = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/exchange-rate/`,
        data
      );
      setQuoterRides(false);
      setIsCarModalStatus(true);
    } catch (e) {
      console.log(e);
    }
  };

  const normalizePhoneNumber = (phone) => {
    // Eliminar cualquier carácter no numérico
    let normalized = phone.replace(/\D/g, "");

    // Verificar si el número ya tiene el prefijo del país
    if (normalized.startsWith("595")) {
      return normalized; // Ya está en formato correcto
    }

    // Si el número comienza con "09", asumir que es Paraguay y reemplazarlo por "595"
    if (normalized.startsWith("09")) {
      return `595${normalized.slice(1)}`;
    }

    // Si no cumple ninguno de los casos, devolver el número tal cual
    return normalized;
  };

  const handleSendWhatsApp = async (row) => {
    if (row?.driver?.phone) {
      try {
        const rideDetails = await api.rides.getOne(row.token);
        const phone = normalizePhoneNumber(row.driver.phone);
        const baseUrl = `${window.location.origin}/rides/${row.token}/confirm/`;

        const formatHourToAmPm = (hourString) => {
          const [hours, minutes] = hourString.split(":").map(Number);
          const period = hours >= 12 ? "p.m." : "a.m.";
          const formattedHour = hours % 12 || 12;
          return `${formattedHour}:${String(minutes).padStart(
            2,
            "0"
          )} ${period}`;
        };

        const message = `Hola ${
          rideDetails.driver.name
        }, por favor confirma o rechaza el viaje accediendo al enlace.

*Detalles del viaje:*

*• Cliente:* ${rideDetails.client.name}
*• Nº de vuelo:* ${rideDetails.flightNumber || "-"}
*• Nombre del pasajero:* ${rideDetails.passenger}
*• Teléfono del pasajero:* ${rideDetails.passengerContact}
*• Fecha:* ${format(parseISO(rideDetails.date), "dd/MM/yyyy")}
*• Hora:* ${formatHourToAmPm(rideDetails.hour)}
*• Lugar de recogida:* ${rideDetails.pickup}
*• Lugar de destino:* ${rideDetails.destination}
*• Vehículo asignado:* ${rideDetails.vehicle.name}
*• Observaciones:* ${rideDetails.observations || "Sin observaciones"}

*Enlace:* ${baseUrl}`;

        setWhatsAppMessage(message);
        setCurrentRow({ phone });
        setShowModal(true);
      } catch (error) {
        console.error("Error al obtener los datos del viaje:", error);
        alert("Hubo un error al generar el mensaje de WhatsApp.");
      }
    } else {
      alert("El conductor no tiene un número de teléfono asignado.");
    }
  };

  const handleDownloadDetail = async (id) => {
    try {
      setLoading(true);

      // Llamar a la API con responseType: 'blob'
      const response = await api.rides.downloadDetails(id);

      // Verificar si la respuesta es válida
      if (!response || !response.data) {
        throw new Error("Respuesta de la API no válida");
      }

      // Crear un Blob para el PDF
      const blob = new Blob([response.data], { type: "application/pdf" });

      // Crear un nombre para el archivo
      const fileName = "traslado.pdf";

      // Crear un enlace invisible para descargar el archivo
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Liberar memoria
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error descargando el detalle:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendWhatsAppReview = (row) => {
    if (row?.passengerContact) {
      const phone = normalizePhoneNumber(row.passengerContact);
      const baseUrl = `${window.location.origin}/rides/${row.token}/review/`;
      const message = `Hola ${row.passenger}, por favor califica el servicio accediendo al siguiente enlace: ${baseUrl}`;

      setReviewPhone(phone);
      setReviewMessage(message);
      setIsReviewModalOpen(true); // abre el modal para editar el mensaje
    } else {
      alert("El pasajero no tiene un número de teléfono asignado.");
    }
  };

  const sendFinalWhatsAppMessage = () => {
    const whatsappUrl = `https://web.whatsapp.com/send?phone=${
      currentRow.phone
    }&text=${encodeURIComponent(whatsAppMessage)}`;
    window.open(whatsappUrl, "_blank");
    setShowModal(false);
  };

  const handleFinalReviewSend = () => {
    const whatsappUrl = `https://web.whatsapp.com/send?phone=${reviewPhone}&text=${encodeURIComponent(
      reviewMessage
    )}`;
    window.open(whatsappUrl, "_blank");
    setIsReviewModalOpen(false);
  };

  const [opacityLevel, setOpacityLevel] = useState(0);

  useEffect(() => {
    if (loading) {
      let intervalId = setInterval(() => {
        setOpacityLevel((prev) => Math.min(prev + 0.1, 1)); // Incrementa la opacidad hasta 1
      }, 500); // Ajusta el intervalo para controlar la velocidad
      return () => clearInterval(intervalId); // Limpia el intervalo al desmontar
    } else {
      setOpacityLevel(1); // Asegúrate de que la opacidad esté al máximo al terminar de cargar
    }
  }, [loading]);

  const handleSearchSubmit = () => {
    setDebouncedSearch(currentSearch); // ahora se activa la búsqueda
  };

  const handleChangeStatus = async (row, newStatus) => {
    console.log(data);
    if (!data || !Array.isArray(data.data)) {
      console.error("handleChangeStatus: data.data no es un arreglo", data);
      return;
    }

    const editFields = {
      client: row.client.id,
      passenger: row.passenger,
      date: row.date,
      hour: row.hour,
      status: newStatus,
    };

    try {
      await api.rides.update(row.id, editFields);
      toast.success("Estado actualizado correctamente");

      const updated = data.data.map((r) =>
        r.id === row.id ? { ...r, status: newStatus } : r
      );

      // Si usas useState para `data` y lo guardás como un objeto con stateCounts y data,
      // hay que mantener ese objeto y actualizar solo la propiedad data:

      setData({
        ...data,
        data: updated,
      });
    } catch (error) {
      console.error("Error al actualizar estado", error);
      throw error;
    }
  };

  return (
    <Layout>
      <div
        className={`p-8 bg-[#F8F9FB] transition-opacity ease-in-out`}
        style={{
          opacity: opacityLevel,
          transition: "opacity 0.5s linear",
        }}
      >
        <ModalForm
          title="Editar mensaje de WhatsApp"
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onSubmit={sendFinalWhatsAppMessage}
          textBtn="Enviar mensaje"
          showSubtitle={false}
        >
          <CustomTextarea
            label="Mensaje"
            type="textarea"
            value={whatsAppMessage}
            onChange={(e) => setWhatsAppMessage(e.target.value)}
            isRequired
            placeholder="Escribe el mensaje que será enviado por WhatsApp"
          />
        </ModalForm>
        <ModalForm
          title="Editar mensaje de evaluación"
          isOpen={isReviewModalOpen}
          onClose={() => setIsReviewModalOpen(false)}
          onSubmit={handleFinalReviewSend}
          textBtn="Enviar mensaje"
          showSubtitle={false}
        >
          <CustomTextarea
            label="Mensaje"
            type="textarea"
            value={reviewMessage}
            onChange={(e) => setReviewMessage(e.target.value)}
            isRequired
            placeholder="Escribe el mensaje que será enviado por WhatsApp"
          />
        </ModalForm>
        <ModalCenter
          isOpen={quoterRides}
          onClose={() => {
            setQuoterRides(false);
            setIsCarModalStatus(true);
          }}
          btnText="Guardar"
          onClick={updateExchange}
        />
        <CarAvailabilityModal
          isOpen={isCarModalStatus}
          onClose={() => setIsCarModalStatus(false)}
        />
        {!quoterRides && !isCarModalStatus && <ToastContainer />}
        <div className="flex justify-between">
          <h1 className="poppins-bold text-lg text-[#1F384C] tracking-wider">
            Tablero
          </h1>
          {ridesWithIssues.length > 0 && (
            <button
              onClick={() => {
                ridesWithIssues.forEach((ride) => {
                  toast.error(
                    `🚨 Viaje con problemas: ${ride.passenger} 
${ride.issues.join("\n")}`,
                    {
                      onClick: () => handleDetailsClick(ride.id),
                      style: { cursor: "pointer", whiteSpace: "pre-line" },
                    }
                  );
                });
              }}
              className="bg-red-100 text-red-700 px-4 py-2 rounded-lg text-sm hover:bg-red-200 transition"
            >
              🚨 Ver viajes con problemas
            </button>
          )}
        </div>

        <div className="flex gap-4 w-[90%] flex-wrap my-10">
          <InfoCard
            title="Agendado"
            titleColor="#A5D3FF"
            value={data.stateCounts?.Agendado}
            tooltip="Servicios programados para fechas futuras (a partir de mañana)."
            onClick={() => setStatus(1)}
          />
          <InfoCard
            title="En espera"
            titleColor="#B0B0B0"
            value={data.stateCounts?.["En espera"]}
            tooltip="Servicios de hoy con vehículo y chofer asignados, pero el chofer no ha confirmado aún, faltando 3 horas o menos para el inicio."
            onClick={() => setStatus(3)}
          />
          <InfoCard
            title="Pendiente"
            titleColor="#FFA500"
            value={data.stateCounts?.Pendiente}
            tooltip="Servicios de hoy sin asignación completa (falta vehículo, chofer o ambos) y con más de 3 horas para su inicio."
            onClick={() => setStatus(2)}
          />
          <InfoCard
            title="Confirmado"
            titleColor="#4AA785"
            value={data.stateCounts?.Confirmado}
            tooltip="Servicios completamente programados, con vehículo y chofer asignados, y confirmación del chofer."
            onClick={() => setStatus(4)}
          />
          <InfoCard
            title="Rechazado"
            titleColor="#E66672"
            value={data.stateCounts?.Rechazado}
            tooltip="Servicios que han sido rechazados, ya sea por problemas con la asignación del vehículo, el chofer o por solicitudes específicas de los clientes."
            onClick={() => setStatus(6)}
          />
          <InfoCard
            title="Cerrado"
            titleColor="#D9D9D9"
            value={data.stateCounts?.Cerrado}
            tooltip="Servicios que ya han sido confirmados, ejecutados y cerrados, finalizando así el proceso de prestación del servicio."
            onClick={() => setStatus(5)}
          />
          <InfoCard
            title="Cancelado"
            titleColor="#BE202F"
            value={data.stateCounts?.Cancelado}
            tooltip="Servicios que fueron cancelados."
            onClick={() => setStatus(7)}
          />
        </div>

        <div className="flex items-center gap-4 flex-wrap">
          <p className="poppins-regular text-[#8F99A6] tracking-wider text-xs">
            Filtrar por:
          </p>
          <div className="poppins-regular flex justify-between w-full gap-4 flex-wrap">
            <DateRangePicker
              selectRange={selectedRange}
              startDate={selectedRange?.startDate}
              endDate={selectedRange?.endDate}
              onRangeChange={handleRangeSelect}
              placeholder="Rango de fecha"
              loading={loading}
            />
            {clients && (
              <CustomSelect
                options={clients}
                value={client}
                onChange={setClient}
                placeholder="Ingresa el nombre del cliente"
                valueKey="id"
                labelKey="name"
                isAutocomplete
                onAddNew={() => {
                  setFlag(true);
                  handleAddNew("client");
                }}
              />
            )}
            <CustomSelect
              options={statusOptions}
              value={status}
              onChange={setStatus}
              placeholder="Estado"
            />

            <CustomSelect
              placeholder="Tipo de traslado"
              type="select"
              valueKey="value"
              labelKey="label"
              value={type}
              onChange={setType}
              options={serviceTypeOptions}
            />

            {drivers && (
              <CustomSelect
                options={drivers}
                value={driverSelect}
                onChange={setDriverSelect}
                placeholder="Conductor"
                labelKey="name"
                valueKey="id"
                isAutocomplete
                onAddNew={() => {
                  setFlag(true);
                  handleAddNew("driver");
                }}
              />
            )}

            {cars && (
              <CustomSelect
                options={cars}
                value={carSelect}
                onChange={setCarSelect}
                placeholder="Vehículo"
                labelKey="name"
                valueKey="id"
                isAutocomplete
                onAddNew={() => {
                  setFlag(true);
                  handleAddNew("car");
                }}
              />
            )}

            <button
              className="poppins-medium flex items-center justify-center bg-transparent border text-[#0080FF] text-xs px-4 py-2 rounded-2xl tracking-wider"
              onClick={clearFilters}
            >
              Limpiar filtros
            </button>
          </div>
          <div className="md:ml-auto mb-5">
            <CustomButton
              text="Agregar viaje"
              onClick={() => setIsModalOpen(true)}
              icon={true}
            />
          </div>
        </div>

        <DashboardTable
          columnsConfig={columnsConfig}
          data={data?.data}
          loading={loading}
          onChangeStatus={(row, newStatus) =>
            handleChangeStatus(row, newStatus)
          }
          onActionClick={(row) => handleDetailsClick(row.id)}
          onCloseTripClick={(row) => {
            handleTripClosure(row);
          }}
          onSendInfo={(row) => handleSendWhatsApp(row)}
          onSendRating={(row) => handleSendWhatsAppReview(row)}
          onDownloadDetail={(row) => handleDownloadDetail(row.id)}
          currentSearch={currentSearch}
          onSearchChange={(e) => setCurrentSearch(e.target.value)}
          onSearchSubmit={handleSearchSubmit}
          searchInputRef={searchInputRef}
        />
        <ModalForm
          title="Agrega un nuevo viaje"
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleFormSubmit}
          textBtn="Agregar viaje"
        >
          {/* Muestra un error general si existe */}
          {error && <p className="text-red-600 mb-4">{error}</p>}

          <div className="grid grid-cols-2 gap-4">
            <div>
              <CustomAutoComplete
                placeholder="Ingresa el nombre del cliente"
                value={clientName}
                onChange={(selectedId) => {
                  setClientName(selectedId);
                  const selectedClient = clients.find(
                    (c) => c.id === selectedId
                  );
                  if (selectedClient?.phone) {
                    setPassengerNumber(selectedClient.phone);
                  }
                }}
                options={clients}
                valueKey="id" // Clave para el valor
                labelKey="name" // Clave para el texto visible
                label="Nombre del cliente"
                onAddNew={() => handleAddNew("client")}
                isRequired
              />
              {fieldErrors.client && (
                <p className="text-red-600 text-sm">{fieldErrors.client[0]}</p>
              )}
            </div>
            <div>
              <CustomTextInput
                label="Nombre del pasajero"
                placeholder="Ingresa el nombre del pasajero"
                type="text"
                value={passenger}
                onChange={(e) => setPassenger(e.target.value)}
                isRequired
              />
              {fieldErrors.passenger && (
                <p className="text-red-600 text-sm">
                  {fieldErrors.passenger[0]}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <CustomPhoneInput
                label="Teléfono del pasajero"
                value={passengerNumber}
                onChange={(phone) => setPassengerNumber(phone)}
              />
              {fieldErrors.passenger_contact && (
                <p className="text-red-600 text-sm">
                  {fieldErrors.passenger_contact[0]}
                </p>
              )}
            </div>
            <div>
              <CustomTextInput
                label="Tipo de traslado"
                placeholder="Selecciona el tipo de traslado"
                type="select"
                value={serviceType}
                onChange={(e) => setServiceType(e.target.value)}
                options={serviceTypeOptions}
                isRequired
              />
              {fieldErrors.serviceType && (
                <p className="text-red-600 text-sm">
                  {fieldErrors.serviceType[0]}
                </p>
              )}
            </div>
          </div>
          {/* Dates & Hours Section */}
          <div className="mb-4">
            {dates.map((item, index) => (
              <div key={index} className="flex items-center gap-2 mb-2">
                <div className="flex-1">
                  <CustomTextInput
                    label="Fecha"
                    placeholder="Ingresa la fecha"
                    type="date"
                    value={item.date}
                    onChange={(e) =>
                      updateDateTime(index, "date", e.target.value)
                    }
                    isRequired
                  />
                  {fieldErrors.date && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.date[0]}
                    </p>
                  )}
                </div>

                <div className="flex-1">
                  <CustomTextInput
                    label="Hora"
                    placeholder="Ingresa la hora"
                    type="time"
                    value={item.hour}
                    onChange={(e) =>
                      updateDateTime(index, "hour", e.target.value)
                    }
                    isRequired
                  />
                  {fieldErrors.hour && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.hour[0]}
                    </p>
                  )}
                </div>

                {dates.length > 1 && (
                  <div className="flex items-center pt-4">
                    <button
                      type="button"
                      onClick={() => removeDateTime(index)}
                      className="text-red-500 hover:text-red-700 text-sm px-2 py-1 rounded"
                      title="Eliminar"
                    >
                      ✕
                    </button>
                  </div>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={addDateTime}
              className="border border-[#BE202F] text-[#BE202F] px-3 py-1 rounded text-sm mt-1"
            >
              + Agregar otra fecha
            </button>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <GooglePlacesInput
                label="Lugar de recogida"
                value={pickup}
                onChange={setPickup}
                placeholder="Ingresa el lugar de recogida"
              />
              {fieldErrors.pickup && (
                <p className="text-red-600 text-sm">{fieldErrors.pickup[0]}</p>
              )}
            </div>
            <div>
              <GooglePlacesInput
                label="Lugar de destino"
                value={destination}
                onChange={setDestination}
                placeholder="Ingresa el lugar de destino"
              />
              {fieldErrors.destination && (
                <p className="text-red-600 text-sm">
                  {fieldErrors.destination[0]}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <CustomAutoComplete
                label="Conductor asignado"
                placeholder="Asigna al conductor"
                value={driver}
                onChange={setDriver}
                options={drivers}
                labelKey="name"
                valueKey="id"
                onAddNew={() => handleAddNew("driver")}
              />
              {fieldErrors.driver && (
                <p className="text-red-600 text-sm">{fieldErrors.driver[0]}</p>
              )}
            </div>

            <div>
              <CustomAutoComplete
                label="Vehículo asignado"
                placeholder="Selecciona el vehículo"
                type="select"
                value={car}
                onChange={setCar}
                options={cars}
                labelKey="name"
                valueKey="id"
                onAddNew={() => handleAddNew("car")}
              />
              {fieldErrors.vehicle && (
                <p className="text-red-600 text-sm">{fieldErrors.vehicle[0]}</p>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <CustomTextInput
                label="Nº de voucher"
                placeholder="Ingresa el nº de voucher"
                type="text"
                value={voucher}
                onChange={(e) => setVoucher(e.target.value)}
              />
              {fieldErrors.voucherNumber && (
                <p className="text-red-600 text-sm">
                  {fieldErrors.voucherNumber[0]}
                </p>
              )}
            </div>
            <div>
              <CustomTextInput
                label="Nº de vuelo"
                placeholder="Ingresa el nº de vuelo"
                type="text"
                value={flightNumber}
                onChange={(e) => setflightNumber(e.target.value)}
              />
              {fieldErrors.flightNumber && (
                <p className="text-red-600 text-sm">
                  {fieldErrors.flightNumber[0]}
                </p>
              )}
            </div>
          </div>
          <div>
            <CurrencyInput
              amount={amount}
              setAmount={setAmount}
              currency={currency}
              setCurrency={setCurrency}
            />
            {fieldErrors.amount && (
              <p className="text-red-600 text-sm">{fieldErrors.amount[0]}</p>
            )}
          </div>
          <div className="">
            <div>
              <CustomTextarea
                label="Observaciones"
                placeholder="Deja las observaciones"
                value={obs}
                onChange={(e) => setObs(e.target.value)}
              />
              {fieldErrors.observations && (
                <p className="text-red-600 text-sm">
                  {fieldErrors.observations[0]}
                </p>
              )}
            </div>
          </div>
        </ModalForm>
        {/* Renderizado condicional del modal */}
        {isAddNewModalOpen && (
          <>
            {addNewType === "client" && (
              <ClientModal
                isOpen={isAddNewModalOpen}
                onClose={closeModal}
                onClientAdded={handleClientAdded}
              />
            )}
            {addNewType === "driver" && (
              <DriverModal
                isOpen={isAddNewModalOpen}
                onClose={closeModal}
                onDriverAdded={handleDriverAdded}
              />
            )}
            {addNewType === "car" && (
              <CarModal
                isOpen={isAddNewModalOpen}
                onClose={closeModal}
                onCarAdded={handleCarAdded}
              />
            )}
          </>
        )}
        <ModalTripClosure
          isOpen={openClosure}
          onClose={() => setOpenClosure(false)}
          element={selectedElement}
          onTripClosure={() => {
            setTripClosure(true);
          }}
        />
      </div>
    </Layout>
  );
}
